module.exports = __webpack_public_path__ + "img/3Dian5_8.323c748e.png";